export const breakpoints = ['335px', '450px', '600px', '1024px', '1240px'];
